import { Stack, Tabs, TabsList, TabsTrigger } from "@altimateai/lego";
import { DownloadTable } from "@/components/downloadTable";
import useFiltersBySearchParams from "@/helpers/useFiltersBySearchParams";
import { useAppState } from "@/modules/app/useAppContext";

interface DiscoverTableControlsProps {
  tab: string;
  onDownloadClick: () => Promise<void>;
  // FE feature-flag gate from ``DiscoverContentV2`` (see
  // ``useFeatureFlag("enableImplementedTab")``). Default off until
  // QA + rollout sign-off; hidden from the tab strip when off.
  implementedTabEnabled?: boolean;
}

const DiscoverTableControls = ({
  tab,
  onDownloadClick,
  implementedTabEnabled = false,
}: DiscoverTableControlsProps) => {
  const { updateSearchParamsByKey } = useFiltersBySearchParams();
  // The SE-curated Priority tab is server-gated per tenant; when enabled it
  // leads the tab strip (and is the default landing tab — see DiscoverContentV2).
  const { enablePriorityTab } = useAppState();
  const priorityTabEnabled = enablePriorityTab ?? false;

  const handleTabChange = (newTab: string) => {
    updateSearchParamsByKey({ tab: newTab, page: "0" });
  };

  return (
    <Stack direction="row" justify="between" align="center" className="al-mb-4 al-mt-4">
      <Stack direction="row" align="center" gap="md">
        <Tabs value={tab} onValueChange={handleTabChange}>
          <TabsList>
            {priorityTabEnabled && <TabsTrigger value="priority">Prioritized</TabsTrigger>}
            <TabsTrigger value="opportunities">All</TabsTrigger>
            {implementedTabEnabled && <TabsTrigger value="implemented">Implemented</TabsTrigger>}
            <TabsTrigger value="groups">Groups</TabsTrigger>
          </TabsList>
        </Tabs>
      </Stack>
      <Stack align="center" gap="md">
        <div id="discover-columnpicker-container" />
        {/* Priority opportunities have no CSV export endpoint, so the
            download control is hidden on that tab. */}
        {tab !== "priority" && (
          <DownloadTable
            handleDownload={onDownloadClick}
            buttonProps={{ variant: "outline", size: "sm" }}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default DiscoverTableControls;
